var map = {
	"./01.jpg": 1157,
	"./02.jpg": 3930,
	"./03.jpg": 5863,
	"./04.jpg": 5628,
	"./05.jpg": 3417,
	"./06.jpg": 1918,
	"./07.jpg": 8427,
	"./08.jpg": 6768,
	"./KIMSAT 01.jpg": 2262,
	"./KIMSAT 02.jpg": 3681,
	"./KIMSAT 03.jpg": 5156,
	"./KIMSAT 04.jpg": 7119,
	"./KIMSAT 05.jpg": 7122,
	"./KIMSAT 06.jpg": 9261,
	"./KIMSAT 07.jpg": 2160,
	"./KIMSAT 08.jpg": 7067,
	"./KIMSAT 09.jpg": 606,
	"./SR 01.jpg": 5382,
	"./SR 02.jpg": 6801,
	"./SR 03.jpg": 8276,
	"./SR 04.jpg": 239,
	"./SR 05.jpg": 242,
	"./SR 06.jpg": 2381,
	"./SR 07.jpg": 5280,
	"./SR 08.jpg": 187,
	"./SR 09.jpg": 3726,
	"./SR 10.jpg": 2036,
	"./SS 01.jpg": 5545,
	"./SS 02.jpg": 5278,
	"./SS 03.jpg": 3323,
	"./SS 04.jpg": 232,
	"./SS 05.jpg": 901,
	"./SS 06.jpg": 8826,
	"./SS 07.jpg": 6567,
	"./SS 08.jpg": 8132,
	"./SS 09.jpg": 9937,
	"./SS 10.jpg": 3899,
	"./SS 11.jpg": 6062,
	"./SS 12.jpg": 9145,
	"./VYRA 01.jpg": 2599,
	"./VYRA 02.jpg": 6104,
	"./VYRA 03.jpg": 933,
	"./VYRA 04.jpg": 3870,
	"./VYRA 05.jpg": 3355,
	"./VYRA 06.jpg": 8188,
	"./VYRA 07.jpg": 2537,
	"./VYRA 08.jpg": 9618,
	"./VYRA 09.jpg": 2287,
	"./VYRA 10.jpg": 3121,
	"./VYRA 11.jpg": 3172
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3582;